import { useEffect, useRef } from "react";
import { Container, Row } from "react-bootstrap";
import "./Why_Choose_Us.css";

const Why_Choose_Us = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("active");
        } else {
          sectionRef.current.classList.remove("active");
        }
      },
      {
        threshold: 0.2,
      },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const features = [
    {
      img: "/assets/images/home/why_choose_us/logo-1.png",
      title: "User-Wise Audio Capture",
      subtitle: "Separate Recordings for Every User",
      desc:
        "Get individual audio tracks for each participant for better clarity and control. Download and manage recordings for each speaker separately.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-2.png",
      title: "Crystal-Clear Host Voice",
      subtitle: "Host-First Audio Control",
      desc:
        "Ensures smooth sessions with zero cross-talk & maximum focus. When the host speaks, background voices are automatically muted no interruptions.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-3.png",
      title: "Interruption Free Meetings",
      subtitle: "One voice at a time. Zero distractions.",
      desc:
        "Users cannot interrupt each other, & participants won’t hear other users unless allowed ensuring complete focus.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-4.png",
      title: "Seamless Product Integration",
      subtitle: "Everything works together, effortlessly",
      desc:
        "Your mobile app, website, admin panel, & host system are fully connected in one unified, easy-to-manage ecosystem.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-5.png",
      title: "Fully Responsive and Scalable",
      subtitle: "Built for today. Ready for tomorrow.",
      desc:
        "Flawlessly adapts across all devices and scales smoothly as your users, data, and business continue to grow.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-6.png",
      title: "Smart & Centralized Management",
      subtitle: "Control everything from one dashboard",
      desc:
        "Manage users, content, analytics, and system settings from a single powerful admin panel—saving time and boosting efficiency.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-7.png",
      title: "Lightning Fast Performance",
      subtitle: "Speed that keeps you ahead",
      desc:
        "Our optimized architecture ensures blazing-fast load times, smooth interactions, and a lag-free experience—even under heavy traffic.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-8.png",
      title: "Enterprise Grade Security",
      subtitle: "Protection you can trust",
      desc:
        "Multiple advanced security layers safeguard your data, ensure privacy, and meet industry compliance standards at every level.",
    },
    {
      img: "/assets/images/home/why_choose_us/logo-9.png",
      title: "Modern Dark-Theme UI",
      subtitle: "Designed to look premium, built for comfort",
      desc:
        "A visually striking dark interface that reduces eye strain, enhances focus, and delivers a truly modern user experience.",
    },
  ];
  return (
    <section className="why_choose_us">
      <Container>
        <div className="cards_holder" ref={sectionRef}>
          <div className="section_header_holder">
            <img
              src="/assets/images/home/why_choose_us/why-choose.png"
              alt="why-choose-title"
              className="why_choose_img scroll_animated_title"
            />
          </div>

          <Row className="cards_wrapper  mt-5 mb-4 g-4">
            {features.map((item, index) => (
              <div
                className="cards_col col-lg-4 col-md-6 col-sm-6 col-12"
                key={index}
              >
                <div className="feature_card">
                  <img src={item.img} alt="card-logo" className="card_logo" />
                  <h5 className="card_title">{item.title}</h5>
                  <p className="card_subtitle">{item.subtitle}</p>
                  <p className="card_desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Why_Choose_Us;